/**
 * Just-in-time privacy notice above Skicka, for codes placed in a public
 * place only. The policy is the customer's own: a link opens in a new tab,
 * a text opens in a modal as plain text (never HTML).
 */
import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { ShieldCheck } from 'lucide-react';
import { PublicPrivacyPolicy } from '../../types/publicReport';

interface PublicReportPrivacyNoticeProps {
    policy: PublicPrivacyPolicy | null;
}

const PublicReportPrivacyNotice: React.FC<PublicReportPrivacyNoticeProps> = ({ policy }) => {
    const [showText, setShowText] = useState(false);

    return (
        <div className="public-report-page__privacy" data-testid="public-report-privacy">
            <ShieldCheck size={18} className="flex-shrink-0 text-muted" aria-hidden="true" />
            <div>
                <p className="mb-0">
                    Undvik att ta med personuppgifter i beskrivningen och på bilderna.
                </p>
                {policy && (
                    <p className="mb-0 mt-1">
                        Fastighetsägaren ansvarar för hur dina uppgifter hanteras.{' '}
                        {policy.url ? (
                            <a href={policy.url} target="_blank" rel="noopener noreferrer">
                                Läs integritetspolicyn
                            </a>
                        ) : (
                            <Button
                                variant="link"
                                className="public-report-page__privacy-link"
                                onClick={() => setShowText(true)}
                            >
                                Läs integritetspolicyn
                            </Button>
                        )}
                        {policy.url && policy.text && (
                            <>
                                {' '}eller{' '}
                                <Button
                                    variant="link"
                                    className="public-report-page__privacy-link"
                                    onClick={() => setShowText(true)}
                                >
                                    visa den här
                                </Button>
                            </>
                        )}
                    </p>
                )}
            </div>

            {policy?.text && (
                <Modal show={showText} onHide={() => setShowText(false)} centered scrollable>
                    <Modal.Header closeButton>
                        <Modal.Title>Integritetspolicy</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="public-report-page__privacy-text">{policy.text}</div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowText(false)}>
                            Stäng
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </div>
    );
};

export default PublicReportPrivacyNotice;
